import React from 'react';

const Footer = () => {
  return (
    <footer className="gc-footer">
      <div className="gc-footer__inner">
        <div className="gc-footer__brand">
          <span className="gc-footer__logo">Guri Coffee</span>
          <p className="gc-footer__tagline">人生の余白時間を、コーヒーとともに。</p>
          <p className="gc-footer__location">石川県小松市 / 南加賀エリア</p>
        </div>
        <div className="gc-footer__links">
          <div className="gc-footer__col">
            <h4 className="gc-footer__col-title">Shop</h4>
            <a href="https://guricoffee.base.shop/" target="_blank" rel="noopener noreferrer" className="gc-footer__link">Online Store (BASE)</a>
          </div>
          <div className="gc-footer__col">
            <h4 className="gc-footer__col-title">Media</h4>
            <a href="https://note.com/gurimonnnu" target="_blank" rel="noopener noreferrer" className="gc-footer__link">note</a>
            <a href="https://gurimonnnu.substack.com/" target="_blank" rel="noopener noreferrer" className="gc-footer__link">Substack</a>
          </div>
          <div className="gc-footer__col">
            <h4 className="gc-footer__col-title">Info</h4>
            <a href="/pages/privacy-policy" className="gc-footer__link">プライバシーポリシー</a>
            <a href="mailto:guri.coffee4945@gmail.com" className="gc-footer__link">お問い合わせ</a>
          </div>
        </div>
      </div>
      <div className="gc-footer__bottom">
        <p className="gc-footer__copy">&copy; {new Date().getFullYear()} GURI COFFEE. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
